import { useProductsHook, useLanguageHook } from "../../../../../Hooks/use-context-hooks";
import { PageText } from "../../../../../components/Text/Text";
import { isEmptyList, FilterProductById, consolidateSpecListsToArray, extractProductNamesFromKeywords, findMatchingProducts } from "../../../../../Utils/helper-functions";
import { isEolProduct } from "../../../../../Utils/product-availability";

import { ProductBackgroundShape } from "../../../../../components/Shape/ProductBackgroundShape";
import { AnimatedComponent } from "../../../../../Hooks/use-framer-motion";
import SpecificationColumns from "../../../../Components/ProductElements/Details/Specifications/SpecificationColumns";

import { GridSystem } from "../../../../Components/GridSystem/GridSystem";
import styles from "./DesktopProductDetails.module.css";
import { ProductButton } from "../ProductButton/ProductButton";
import UPCCodes from "../../../../Components/ProductElements/Details/UPCCodes/UPCCodes";
import FeatureLogos from "../../../../Components/ProductElements/Details/FeatureLogos/FeatureLogos";
import FeatureVideos from "../../../../Components/ProductElements/Details/FeatureVideo/FeatureVideos";
import FeatureResources from "../../../../Components/ProductElements/Details/FeatureResources/FeatureResources";
import ColorLegend from "../../../../Components/ProductElements/Details/ColorLegend/ColorLegend";
import FeatureHeroResources from "../../../../Components/ProductElements/Details/FeatureResources/FeatureHeroResources";
import { MatchingProductComponent } from "../../../../Components/ProductElements/MatchingProduct/MatchingProductComponent";
import { DetailSection } from "../DetailSection/DetailSection";
import Product3DViewer from "../../../Home/Product3DViewer";
import Product3DViewerWithModal from "../../../Home/Product3DViewerWithModal";
import FeatureDefinitionText from "../../../../../Shared/Components/FeatureDefinitionText/FeatureDefinitionText";
import { translatedText } from "../../../../Data/Language/translated-text";
export const DesktopProductDetailsPage = ({ productId }) => {
    const { publicProducts } = useProductsHook();
    const { language } = useLanguageHook();

    const productDetails = FilterProductById(publicProducts, productId);
    const [productObject] = productDetails;

    console.log({ productDetails, productObject })

    if (!productObject) {
        return null;
    }

    const isEol = isEolProduct(productObject);

    const specsArray = consolidateSpecListsToArray(productObject);
    const relatedProducts = extractProductNamesFromKeywords(specsArray);
    const matchingProducts = findMatchingProducts(relatedProducts, publicProducts);
    console.log('match ',matchingProducts)
    const videoList = productObject?.videos;
    const hasVideos = !isEmptyList(videoList);
    const fakeImage = "f"
    const cleanedVideos = Array.isArray(videoList)
        ? videoList.filter(item => {
            if (typeof item === 'string') return item.trim() !== '';
            return item != null;
        })
        : [];

    const cleanLogos = Array.isArray(productObject.logos)
        ? productObject.logos.filter((logo) => {
            if (typeof logo === "string") return logo.trim() !== "";
            return logo != null;
        })
        : [];

    const hasLogos = cleanLogos.length > 0;
    const availText =
        language === "FR"
            ? productObject.availability === "Available"
                ? "Disponible"
                : productObject.availability === "EOL"
                    // ? "Fin de vie"
                    ? "EOL"
                    : productObject.availability
            : productObject.availability;
    // const availText = isEol
    //     ? "EOL"
    //     : productObject.availability || (language === "FR" ? "Disponible" : "");
    const interactiveImage = language && language === 'EN' ? productObject.interactiveImageEN : productObject.interactiveImageFR
    const translatedSectionTitles = language && language === 'EN' ? {
        upcCodes: translatedText.EN.upcCodes,
        technology: translatedText.EN.technology,
        resources: translatedText.EN.resources,
        relatedProducts: translatedText.EN.relatedProducts,
    } : {
        upcCodes: translatedText.FR.upcCodes,
        technology: translatedText.FR.technology,
        resources: translatedText.FR.resources,
        relatedProducts: translatedText.FR.relatedProducts,
    };

    return (
        <div className={styles.pageContainer}>
            <GridSystem>
                <div className={styles.applianceHeaderWrapper}>
                    <div className={styles.applianceHeaderWrapperDiv1}>
                        <AnimatedComponent type="bounceEffect">
                            <PageText type='productPageTertiary'>{availText}</PageText>
                        </AnimatedComponent>

                        <AnimatedComponent type="bounceEffect">
                            <PageText type='productPageTitle'>{productObject.title}</PageText>
                        </AnimatedComponent>

                        {/* <AnimatedComponent type="wipeEffect" directionStart='left' delay={0.1}>
                            <PageText type='productPageSubtitle'>{productObject.subtitle}</PageText>
                        </AnimatedComponent> */}
                        {/* <AnimatedComponent type="wipeEffect" directionStart="left" delay={0.1}> */}
                        <FeatureDefinitionText
                            text={productObject.subtitle}
                            product={productObject}
                            textType="productPageSubtitle"
                            categoryRestrictive={true}
                        />
                        {/* </AnimatedComponent> */}

                        {!isEol && (
                            <div className={styles.applianceHeaderWrapperDiv1BtnWrapper}>
                                <ProductButton product={productObject} />
                            </div>
                        )}
                    </div>

                    <div className={styles.applianceHeaderWrapperDiv2}>
                        <div className={styles.imageShapeGroupWrapper}>
                            <div className={styles.productImageForShape}>
                                <div
                                    className={`${styles.productImage} ${interactiveImage ? styles.productImage3D : styles.productImageStatic
                                        }`}
                                >
                                    {interactiveImage ? (
                                        // <Product3DViewer
                                        //     src={interactiveImage}
                                        //     title={`${productObject.title} 3D Viewer`}
                                        // />
                                        // <Product3DViewerWithModal
                                        //     src={interactiveImage}
                                        //     // title={`${productObject.title} 3D Viewer`}
                                        //     title={`${productObject.title}`}
                                        // />
                                        <Product3DViewerWithModal

                                            src={interactiveImage}
                                            title={`${productObject.title} 3D Viewer`}
                                            fallbackImage={`${process.env.REACT_APP_AWS_URL}/${productObject.image}`}
                                            fallbackAlt={productObject.title}
                                        />
                                    ) : (
                                        <img
                                            loading="lazy"
                                            src={`${process.env.REACT_APP_AWS_URL}/${productObject.image}`}
                                            alt={productObject.title}
                                        />
                                    )}
                                </div>
                                {/* <div className={styles.productImage}>
                                    {
                                        interactiveImage ?
                                            <Product3DViewer
                                                src={interactiveImage}
                                                title={`${productObject.title} 3D Viewer - Wide`}
                                                // variant="wide"
                                            />
                                           
                                            :
                                            <img
                                                loading='lazy'
                                                src={`${process.env.REACT_APP_AWS_URL}/${productObject.image}`}
                                                alt={`${productObject.title}`}
                                            />
                                    }



                                </div> */}
                            </div>
                            <ProductBackgroundShape className={styles.productBackgroundShapeContainer} />
                        </div>
                    </div>

                    <div className={styles.applianceHeaderWrapperDiv3}>
                        <ColorLegend colours={productObject.colour} />
                    </div>

                    <div className={styles.applianceHeaderWrapperDiv4} style={{ paddingTop: '2rem' }}>
                        <FeatureHeroResources product={productObject} />
                    </div>
                </div>
            </GridSystem>

            {/* <DetailSection containerBackgroundColor="var(--color-gray-06)">
                <SpecificationColumns product={productObject} />
            </DetailSection> */}
            <DetailSection
                key={`spec-section-${productObject._id}`}
                containerBackgroundColor="var(--color-gray-06)"
            >
                <SpecificationColumns
                    key={`spec-columns-${productObject._id}`}
                    product={productObject}
                />
            </DetailSection>

            {hasVideos && (
                <FeatureVideos product={{ ...productObject, videos: cleanedVideos }} />
            )}

            {productObject.sections.length > 0 && (
                <DetailSection title={translatedSectionTitles.resources} containerBackgroundColor="var(--color-gray-05)">
                    <FeatureResources product={productObject} />
                </DetailSection>
            )}

            {productObject.upcCode && productObject.upcCode.length > 0 && (
                <DetailSection title={translatedSectionTitles.upcCodes} containerBackgroundColor="var(--color-gray-05)">
                    <UPCCodes product={productObject} />
                </DetailSection>
            )}

            {/* {productObject.logos && productObject.logos.length > 0 || productObject.logos !== '' && (
                <DetailSection title={translatedSectionTitles.technology} containerBackgroundColor="var(--color-gray-05)">
                    <FeatureLogos product={productObject} />
                </DetailSection>
            )} */}

            {hasLogos && (
                <DetailSection
                    title={translatedSectionTitles.technology}
                    containerBackgroundColor="var(--color-gray-05)"
                >
                    <FeatureLogos product={{ ...productObject, logos: cleanLogos }} />
                </DetailSection>
            )}
            {matchingProducts.length > 0 && (
                // <DetailSection title="Related home appliances" containerBackgroundColor="var(--color-gray-05)">
                <DetailSection title={translatedSectionTitles.relatedProducts} containerBackgroundColor="var(--color-gray-05)">
                    <MatchingProductComponent product={matchingProducts} />
                </DetailSection>
            )}
        </div>
    );
};